import React from 'react';
// styles
import { RelatedLinksStyled } from './styles';

export default () => {
  const linkItems = [
    {
      linkUrl: '/life-insurance/variable-universal-life-insurance-vul/underlying-fund-information/prospectuses-performance-and-reports/',
      linkId: 'related-links-prospectuses-performance-and-reports',
      linkText: 'Prospectus, Reports, and Performance History',
      ariaLabel: '',
      isOutgoingLink: false,
      children: '',
    },
    {
      linkUrl: '/life-insurance/variable-universal-life-insurance-vul/underlying-fund-information/',
      linkId: 'related-links-underlying-fund-information',
      linkText: 'Underlying Fund Information',
      ariaLabel: '',
      isOutgoingLink: false,
      children: '',
    },
    {
      linkUrl: 'https://connect.rightprospectus.com/NorthwesternMutual?site=Funds',
      linkId: 'related-links-nm-series-fund',
      linkText: 'NM Series Fund Inc.',
      ariaLabel: '',
      isOutgoingLink: false,
      children: '',
    },
  ];

  return (
    <RelatedLinksStyled
      sectionId='related-links-vul-page'
      linkItems={linkItems}
      moduleName='related-links'
      moduleVariation='A'
      backgroundVariant='lightA'
      themeType='lightTheme'
      disableBottomPadding />
  );
};
